import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';
import { DealEstimationHeader } from '~/models/DealEstimationHeader';

const paths = {
  index: '/deals/:deal_id/deal_estimation_headers',
  show: '/deals/:deal_id/deal_estimation_headers/:id'
};

type TIndex = (dealId: number | null) => SwrReturnType<DealEstimationHeader[]>;
type TShow = (
  dealId: number | null,
  id: number | null
) => SwrReturnType<DealEstimationHistoryContext>;
type ReturnType = {
  index: TIndex;
  show: TShow;
};

export const useDealEstimationHeaders = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    const { data, mutate, isLoading, error } = useSWR<DealEstimationHeader[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  const show: TShow = (dealId: number | null, id: number | null) => {
    const { data, mutate, isLoading, error } =
      useSWR<DealEstimationHistoryContext>(
        dealId === null || id === null
          ? null
          : paths.show
              .replace(':deal_id', String(dealId))
              .replace(':id', String(id))
      );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  return { index, show };
};
